import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../context/AppContext";
import { Link } from "react-router-dom";
import { OrdersData } from "../../../../network/api/OrdersData";
import Pagination from "../../../../../../components/Pagination";
import CardLoader from "../../../../../../components/CardLoader";
import { highlightText } from "../../../../../../utils/highlight";


export default function Orders() {

    const { setPageTitle, setPageUserID } = useAppContext();

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const [orderList, setOrderList] = useState([]);
    const [reload, setReload] = useState(null);

    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: []
    });

    const [pageFilters, setPageFilters] = useState({
        page: null,
        limit: 10
    });

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pageProps.totalPages) {
            setPageProps((prev) => ({
                ...prev,
                page: page,
            }));

            setPageFilters((prev) => ({
                ...prev,
                page: page,
            }));
        }

    };

    const handleLimitChange = (value) => {
        setPageFilters((prev) => ({
            ...prev,
            limit: value,
        }));

    };

    const [searchValue, setSetchValue] = useState(null);
    const handleSerchChange = (e) => {
        e.preventDefault();
        const { value } = e.target;
        setSetchValue(value);

        if (value.length >= 3) {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                guest_email: value,
                invoice_number: value,
                transaction_reference: value,
            }));
        }

        if (value.length === 0) {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                guest_email: null,
                invoice_number: null,
                transaction_reference: null,
            }));
        }

    }

    const [selectedOrder, setSelectedOrder] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleViewDetails = (order) => {
        setSelectedOrder(order);
        setShowModal(true);
    };

    useEffect(() => {
        const fetchLogs = async () => {
            setIsLoading(true);
            setErrorMessage(null);

            try {
                const response = await OrdersData({ pageFilters: pageFilters });
                
                if (response.status === "success") {
                    //console.log("Orders response", response);

                    if (JSON.stringify(response.data.data) !== JSON.stringify(orderList)) {
                        setOrderList(response.data.data);
                        setPageProps({
                            page: response.data.page,
                            totalPages: response.data.total_pages,
                            totalEntries: response.data.total_records,
                            entryLimit: response.data.limit,
                            visiblePages: response.data.visible_pages,
                        })
                    }

                } else {
                    setErrorMessage({ code: response.code, message: response.message });
                }
            } catch (err) {
                setErrorMessage({ code: "500", message: "Failed to load users." });
            } finally {
                setIsLoading(false);
            }
        };

        fetchLogs();
    }, [pageFilters, orderList, reload]);

    useEffect(() => {
        setPageUserID(null);
        setPageTitle("Orders");
    }, [setPageTitle, setPageUserID]);

    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row page-titles">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item  "><Link to={`/shop`}>Shop</Link></li>
                            <li className="breadcrumb-item  active"><span>Product Orders</span></li>
                        </ol>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card custom-card">
                                {(isLoading || errorMessage) && (<CardLoader errorMessage={errorMessage} onRetry={() => { setReload(!reload); }} />)}

                                <div className="card-body custom-card">
                                    <div id="guestTable-all-1_wrapper" className="table-responsive dataTables_wrapper no-footer">
                                        <div className="dataTables_length" id="page_limit">
                                            <label>
                                                Show{" "}
                                                <select
                                                    name="page_limit"
                                                    aria-controls="example3"
                                                    className=""
                                                    value={pageProps.entryLimit}
                                                    onChange={(e) => handleLimitChange(Number(e.target.value))}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>{" "}
                                                entries
                                            </label>
                                        </div>
                                        <div id="example3_filter" className="dataTables_filter">
                                            <label>
                                                Search:
                                                <input
                                                    type="search"
                                                    className=""
                                                    placeholder=""
                                                    aria-controls="example3"
                                                    onChange={handleSerchChange}
                                                />
                                            </label>
                                        </div>
                                        <table className="table table-sm mb-0">
                                            <thead>
                                                <tr>
                                                    <th className="py-2 px-2 align-middle">
                                                        <div className="form-check custom-checkbox m-0">
                                                            <input type="checkbox" className="form-check-input" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="py-2 px-2 align-middle">Order</th>
                                                    <th className="py-2 px-2 align-middle">Date</th>
                                                    <th className="py-2 px-2 align-middle">Items</th>
                                                    <th className="py-2 px-2 align-middle">Transaction Ref</th>
                                                    <th className="py-2 px-2 align-middle">Invoice Number</th>
                                                    <th className="py-2 px-2 align-middle">Shipping Address</th>
                                                    <th className="py-2 px-2 text-end align-middle">Status</th>
                                                    <th className="py-2 px-2 text-end align-middle">Amount</th>
                                                    <th className="py-2 px-2 text-end align-middle"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orderList.map((order, i) => {
                                                    const total = parseFloat(order.price) * parseInt(order.quantity);
                                                    return (
                                                    <tr key={order.id}>
                                                        <td className="py-2 px-2 align-middle">
                                                            <div className="form-check custom-checkbox m-0">
                                                                <input type="checkbox" className="form-check-input" id={`checkbox${i}`} />
                                                                <label className="form-check-label" htmlFor={`checkbox${i}`}></label>
                                                            </div>
                                                        </td>
                                                        <td className="py-2 px-2 align-middle">
                                                            <p><strong className="text-primary">#{order.id}</strong></p>
                                                            <p>{highlightText(order.guest_email, searchValue)}</p>
                                                        </td>
                                                        <td className="py-2 px-2 align-middle">{order.created_at}</td>
                                                        <td className="py-2 px-2 d-flex align-items-center gap-3 align-middle">
                                                            <img src={order.product.image_url} alt={order.product.name} style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "6px" }} />
                                                            <div>
                                                                <div>{order.product.name}</div>
                                                                <small>Qty: {order.quantity}</small><br />
                                                                <small>R{order.price}</small>
                                                            </div>
                                                        </td>
                                                        <td className="py-2 px-2 align-middle">{highlightText(order.transaction_reference, searchValue)}</td>
                                                        <td className="py-2 px-2 align-middle">{highlightText(order.invoice_number, searchValue)}</td>
                                                        <td className="py-2 px-2 align-middle">
                                                            <button type="button" className="btn btn-link p-0" onClick={() => handleViewDetails(order)}>
                                                                View
                                                            </button>
                                                        </td>
                                                        <td className="py-2 px-2 text-end align-middle">
                                                            <span className={`badge badge-${order.status === "paid" ? "success" : order.status === "pending" ? "warning" : order.status === "failed" ? "danger" : "secondary"} badge-sm light`}>
                                                                {order.status}
                                                            </span>
                                                        </td>
                                                        <td className="py-2 px-2 text-end align-middle">${total.toFixed(2)}</td>
                                                        <td className="py-2 px-2 text-end align-middle">
                                                            <div className="dropdown text-sans-serif">
                                                                <button className="btn btn-primary tp-btn-light sharp" type="button" data-bs-toggle="dropdown">
                                                                    <span><i className="fa fa-ellipsis-v"></i></span>
                                                                </button>
                                                                <div className="dropdown-menu dropdown-menu-end border py-0">
                                                                    <div className="py-2">
                                                                        <button className="dropdown-item" onClick={() => handleViewDetails(order)}>View Details</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                        <Pagination
                                            pageProps={pageProps}
                                            onPageChange={handlePageChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal && selectedOrder && (
                <div className="modal show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Order #{selectedOrder.id} Details</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <p><strong>Guest Email:</strong> {selectedOrder.guest_email}</p>
                                <p><strong>Invoice Number:</strong> {selectedOrder.invoice_number}</p>
                                <p><strong>Transaction Ref:</strong> {selectedOrder.transaction_reference}</p>
                                <p><strong>Shipping Address:</strong> {selectedOrder.shipping_address || "N/A"}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </UserPageLayout>
    );
}